<div class="setup-guide-sidebar">
  <div class="sidebar-sticky-header">
    <div class="sidebar-header-top">
      <div class="hide-guide-button" (click)="dismissSidebar()">
        <mat-icon>arrow_forward</mat-icon>
        @if (allStepsComplete$ | async) {
          <span translate="SETUP_GUIDE.DISMISS_SETUP_GUIDE"></span>
        } @else {
          <span translate="SETUP_GUIDE.HIDE_SETUP_GUIDE"></span>
        }
      </div>
    </div>

    @if (enableAiAssistant$ | async) {
      <div class="sidebar-tabs">
        <button
          type="button"
          class="sidebar-tab-button"
          [class.active]="activeTab === SetupConstants.SETUP"
          (click)="setActiveTab(SetupConstants.SETUP)"
        >
          <span translate="SETUP_GUIDE.TABS.SETUP"></span>
        </button>
        <button
          type="button"
          class="sidebar-tab-button"
          [class.active]="activeTab === SetupConstants.AI"
          (click)="setActiveTab(SetupConstants.AI)"
        >
          <span translate="SETUP_GUIDE.TABS.AI_ASSISTANT"></span>
        </button>
      </div>
    }
  </div>
  <div class="sidebar-tab-content">
    @if (activeTab === SetupConstants.SETUP) {
      <div class="setup-tab-panel">
        <div class="progress-section">
          @let completedTasks = (completedTasks$ | async) ?? 0;
          @let totalTasks = (totalTasks$ | async) ?? 0;
          <div class="progress-label">{{ completedTasks }} of {{ totalTasks }} Complete</div>
          <div class="progress-bar-wrapper">
            <div class="progress-bar-fill" [style.width.%]="(completedTasks / totalTasks) * 100"></div>
          </div>
        </div>

        <div class="sidebar-steps">
          @for (step of steps$ | async; track $index) {
            <gb-setup-guide-step
              [step]="step"
              [isSidebar]="true"
              [allSteps]="(steps$ | async) || []"
            ></gb-setup-guide-step>
          }
        </div>

        <div class="help-section">
          <span class="help-text" translate="SETUP_GUIDE.NEED_MORE_HELP"></span>
          <a class="help-link" [gbRouteNewTab]="'/help'">
            <span translate="SETUP_GUIDE.CHECK_OUT_HELP_SECTION"></span>
            <gb-icon icon="caret-forward-outline" height="18px"></gb-icon>
          </a>
        </div>
      </div>
    } @else {
      <gb-setup-guide-ai-tab
        [autoFillFormType]="autoFillFormType$ | async"
        [aiPromptPlaceholder]="(aiPromptPlaceholder$ | async) || ''"
        [shouldShowSetupWithAI]="(shouldShowSetupWithAI$ | async) ?? false"
      ></gb-setup-guide-ai-tab>
    }
  </div>
</div>
